import React, { useEffect, useRef } from "react";
import styles from "./Pagination.module.css";

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  isEvent?: boolean;
  onPageChange: (page: number) => void;
  greenStyle?: boolean;
  scrollToTop?: () => void;
}

const Pagination: React.FC<PaginationProps> = ({
  totalItems,
  itemsPerPage,
  currentPage,
  isEvent,
  onPageChange,
  greenStyle,
  scrollToTop,
}) => {
  const totalPages = Math?.ceil(totalItems / itemsPerPage);
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const startPage = Math?.max(Math?.min(currentPage - 2, totalPages - 4), 0);
  const displayedPages = pages?.slice(startPage, startPage + 4);
  const prevPageRef = useRef(currentPage);

  const handlePageClick = (page: number) => {
    onPageChange(page);
  };

  useEffect(() => {
    if (prevPageRef.current !== currentPage) {
      if (scrollToTop) {
        scrollToTop();
      }
    }
    prevPageRef.current = currentPage;
  }, [currentPage, scrollToTop]);

  return (
    <div className={isEvent ? styles.paginationWhiteGreen : styles.pagination}>
      <button
        onClick={() => {
          if (currentPage > 1) onPageChange(currentPage - 1);
        }}
        disabled={currentPage === 1}
        className={greenStyle ? styles.buttonGreen : styles.button}
      >
        &lt;
      </button>
      {displayedPages?.map((page) => (
        <button
          key={page}
          onClick={() => handlePageClick(page)}
          className={`${greenStyle ? styles.buttonGreen : styles.button} ${
            currentPage === page
              ? greenStyle
                ? styles.buttonGreenActive
                : styles.active
              : ""
          }`}
        >
          {page}
        </button>
      ))}
      <button
        onClick={() => {
          if (currentPage < totalPages) onPageChange(currentPage + 1);
        }}
        disabled={currentPage === totalPages}
        className={greenStyle ? styles.buttonGreen : styles.button}
      >
        &gt;
      </button>
    </div>
  );
};

export default Pagination;
